import React, { useState } from "react";
import {
  Button,
  Grid,
  Paper,
  styled,
  TextField,
  Typography,
  Box,
  Chip
} from "@mui/material";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Field, Form } from "react-final-form";
import CalendarPicker from "../../pickers/CalenderPicker";
import { fetchFosaMedicalItems, getClaims } from "../../action";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem 1rem",
}));

function MedicalItemsFilter() {
  const { t } = useTranslation();
  const [dropValue, setDropValue] = useState(0);
  const [showCalendar, setShowCalendar] = useState(false);
  const [searchFilters, setSearchFilters] = useState({
      name: "",
      code: "",
  });
  const [label, setLabel] = useState("Enter CAMU No.");
  const SignInSuccess = useSelector((state) => state);
  const dispatch = useDispatch();

  let healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];

  const handleChange = (event) => {
    const value = event.target.value;
    setDropValue(value);
    getLabel(value);
  };

  const handleSearch = () => {
    let params = buildQueryParams({
      filters: {},
      orderBy: ["name"],
      first: 10,
    });
    if (
      SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]
    ) {
      dispatch(fetchFosaMedicalItems(healthData?.location?.parent?.uuid, params));
    }
    //dispatch(getClaims(params));
  };

  const handleClear = () => {
    setSearchFilters({
      name: "",
      code: "",
    });
    let params = buildQueryParamsClear({
      filters: {},
      orderBy: ["name"],
      first: 10,
    });
    if (
      SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]
    ) {
      dispatch(fetchFosaMedicalItems(healthData?.location?.parent?.uuid, params));
    }
    //dispatch(getClaims(params));
  };

  const buildQueryParamsClear = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if (!!state.first) {
      params.push(`first: ${state.first}`);
    }
    if (!!SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]) {
      params.push(
        `priceListId: "${SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.itemsPricelist?.uuid}"`
      );
    }
    return params;
  };

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if(searchFilters.code) {
      params.push(`code: "${searchFilters.code}"`);
    }
    if(searchFilters.name) {
      params.push(`name: "${searchFilters.name}"`);
    }
    if (!!state.first) {
      params.push(`first: ${state.first}`);
    }
    if (!!SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]) {
      params.push(
        `priceListId: "${SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.itemsPricelist?.uuid}"`
      );
    }
    return params;
  };

  const getLabel = (value) => {
    switch (value) {
      case 1:
        setLabel("Nom");
        break;
      case 2:
        setLabel("Code");
        break;
      default:
        setLabel("Nom");
        break;
    }
  };

  const searchType = [
    {
      value: 2,
      label: t("Code"),
    },
    {
      value: 1,
      label: t("Nom"),
    },
  ];

  const SelectedFilters = () => {
    return (
      <Grid style={{
        display: "flex", 
        flexDirection: "row", 
        gap: "0.5rem", 
        marginLeft: "1.4rem", 
        paddingBottom: "1.4rem" 
      }}>
        {searchFilters.name && <Chip label={searchFilters.name} />}
        {searchFilters.code && <Chip label={searchFilters.code} />}
      </Grid>
    )
  } 

  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader>
            <Grid item alignItems="center">
              <Typography variant="h6">{t("Search Criteria")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <Form
            autoComplete="off"
            onSubmit={(values) => {
              console.log(values);
            }}
            render={({ handleSubmit, form }) => (
              <form onSubmit={handleSubmit}>
                <Grid
                  style={{
                    display: "flex",
                    paddingLeft: "1rem",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Grid item xs={3} className="common-input">
                    <Typography color="#000" fontSize="14">
                      {t("Search Criteria")}
                    </Typography>
                    <Field
                      name="typeOfSearch"
                      component={Dropdown}
                      options={searchType}
                      input={{ value: dropValue, onChange: handleChange }}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    {dropValue !== 0 && (
                      <Typography color="#000" fontSize="24">
                        {t(label)}
                      </Typography>
                    )}
                    {dropValue === 1 && (
                      <TextField
                        name="name"
                        value={searchFilters.name}
                        onChange={(e) => {
                          setSearchFilters(prev => ({
                            ...prev,
                            name: e.target.value,
                          }))
                        }}
                        size="small"
                        type="text"
                        autoComplete="off"
                      />
                    )}

                    {dropValue === 2 && (
                      <TextField
                        name="code"
                        value={searchFilters.code}
                        onChange={(e) => {
                          setSearchFilters(prev => ({
                            ...prev,
                            code: e.target.value,
                          }))
                        }}
                        size="small"
                        type="text"
                        autoComplete="off"
                      />
                    )}
                  </Grid>
                  {dropValue !== 0 && (
                    <Grid
                      item
                      xs={8}
                      style={{ display: "flex", marginTop: "1.4rem" }}
                    >
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSearch}
                        >
                          {t("Search")}
                        </Button>
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleClear}
                          style={{ marginLeft: "1rem" }}
                        >
                          {t("Clear")}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </form>
            )}
          />
          <SelectedFilters />
        </StyledPaper>
      </Grid>
    </Grid>
  );
}

export default MedicalItemsFilter;
